import { BreakdownItem } from '@/components/BreakdownTooltip';
import { amountPaymentPurpose } from '@/pages/GenerateInvoice/invoiceTotals';
import { FreelancerInvoiceSubmissionResource } from '@/types/resources';
import { renderCurrencyCodeSign, renderInvoiceAmount } from '@/utils/helpers';

type AmountRow = NonNullable<
  FreelancerInvoiceSubmissionResource['amounts']
>[number];
type BonusRow = NonNullable<
  FreelancerInvoiceSubmissionResource['bonuses']
>[number];

/** One tooltip line per amount: purpose on the left, hours + value on the right. */
export const amountBreakdownItems = (
  amounts: AmountRow[],
  currency: string,
): BreakdownItem[] => {
  const sign = renderCurrencyCodeSign(currency);
  return amounts.map((a) => {
    const purpose = amountPaymentPurpose(a);
    return {
      label: purpose || '—',
      note: a.hours != null ? `${a.hours}h` : undefined,
      value: `${sign}${renderInvoiceAmount(a.amount)}`,
    };
  });
};

/** One tooltip line per bonus: name on the left, value on the right. */
export const bonusBreakdownItems = (
  bonuses: BonusRow[],
  currency: string,
): BreakdownItem[] => {
  const sign = renderCurrencyCodeSign(currency);
  return bonuses.map((b) => ({
    label: b.purpose || 'Bonus',
    value: `${sign}${renderInvoiceAmount(b.amount)}`,
  }));
};
